<template>
    <b-modal ref="modal" centered hide-header  no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{title}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group"  v-if="formData != null">
                <div class="form-row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('COMPANY')">
                            <inputvalidation :formerror="formError" name="companyId">
                                <b-form-select :options="userCompanies.root" v-model="formData.companyId" value-field="companyId" text-field="companyName">
                                </b-form-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <!--div class="form-row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('SUBCOMPANY')">
                            <inputvalidation :formerror="formError" name="subCompanyId">
                                <b-form-select :options="userSubCompanies.root" v-model="formData.subCompanyId" value-field="subCompanyId" text-field="subCompanyName">
                                </b-form-select></inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div-->
          </div>
            <div class="text-center mt-lg mb-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import Api from '@/api/flow/FlowOperatorObligations.js';
import CompaniesApi from '@/api/admin/UserCompanies';
import SubCompaniesApi from '@/api/admin/UserSubCompanies';

export default
{
    name: 'CopyFlowForm',
    props: ['value'],
    data()
    {
        const me = this;
        return {
            title: '',
            userCompanies: {},
            userSubCompanies: {},
            formError: {},     
            formData: null,
        };
    },
    methods:
    {
        async submitData(item)
      {
          const me = this;
            try
            {
                const val = await Api.copyFlow(item);

                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.close();
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
      },
        async getCompanies()
      {
          const me = this;
          try
          {
              const data = await CompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getSubCompanies()
      {
          const me = this;
          try
          {
              const data = await SubCompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userSubCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
        close()
        {
            const me = this;
            me.formData = null;
            me.userCompanies = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                me.title = val.description;
                await me.getCompanies();
                await me.getSubCompanies();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
